// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InfoCircleTwoToneSvg from "@fishx/icons-svg/es/asn/InfoCircleTwoTone";
import FishxIcon from '../components/FishxIcon';

var InfoCircleTwoTone = function InfoCircleTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: InfoCircleTwoToneSvg
  }));
};

InfoCircleTwoTone.displayName = 'InfoCircleTwoTone';
export default React.forwardRef(InfoCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/InfoCircleTwoTone.js
// module id = 2974
// module chunks = 0